import { render } from "./FbFormula.vue?vue&type=template&id=a646df42"
import script from "./FbFormula.vue?vue&type=script&lang=js"
export * from "./FbFormula.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__